import React from 'react';
import { Box, Container, SimpleGrid, Stack, Text, Link, Icon, useColorModeValue } from '@chakra-ui/react';
import { FaGithub, FaTwitter, FaDiscord, FaTelegram, FaMedium, FaBook } from 'react-icons/fa';

const Footer = () => {
  const bgColor = useColorModeValue('gray.800', 'gray.900');
  const textColor = useColorModeValue('gray.400', 'gray.500');

  return (
    <Box bg={bgColor} color="white" py={10}>
      <Container maxW="container.xl">
        <SimpleGrid columns={{ base: 1, md: 4 }} spacing={8}>
          <Stack spacing={4}>
            <Text fontSize="lg" fontWeight="bold">Resources</Text>
            <Link href="https://docs.solana.com" isExternal color={textColor} _hover={{ color: 'cyan.400' }}>
              Solana Docs
            </Link>
            <Link href="https://internetcomputer.org/docs" isExternal color={textColor} _hover={{ color: 'cyan.400' }}>
              Internet Computer Docs
            </Link>
            <Link href="/whitepaper" color={textColor} _hover={{ color: 'cyan.400' }}>
              HODL Whitepaper
            </Link>
            <Link href="https://solana.com" isExternal color={textColor} _hover={{ color: 'cyan.400' }}>
              Solana
            </Link>
            <Link href="https://internetcomputer.org" isExternal color={textColor} _hover={{ color: 'cyan.400' }}>
              Internet Computer
            </Link>
          </Stack>

          <Stack spacing={4}>
            <Text fontSize="lg" fontWeight="bold">Community</Text>
            <Link href="https://discord.gg/tAKng35W" isExternal color={textColor} _hover={{ color: 'cyan.400' }}>
              <Icon as={FaDiscord} mr={2} />
              Join Discord
            </Link>
            <Link href="https://t.me/hodlProtocal" isExternal color={textColor} _hover={{ color: 'cyan.400' }}>
              <Icon as={FaTelegram} mr={2} />
              Telegram
            </Link>
          </Stack>

          <Stack spacing={4}>
            <Text fontSize="lg" fontWeight="bold">Social Links</Text>
            <Link href="https://x.com/hodlprotocal?s=21" isExternal color={textColor} _hover={{ color: 'cyan.400' }}>
              <Icon as={FaTwitter} mr={2} />
              Twitter
            </Link>
            <Link href="https://discord.gg/tAKng35W" isExternal color={textColor} _hover={{ color: 'cyan.400' }}>
              <Icon as={FaDiscord} mr={2} />
              Discord
            </Link>
            <Link href="https://t.me/hodlProtocal" isExternal color={textColor} _hover={{ color: 'cyan.400' }}>
              <Icon as={FaTelegram} mr={2} />
              Telegram
            </Link>
          </Stack>
        </SimpleGrid>

        <Box borderTopWidth={1} borderStyle="solid" borderColor="gray.700" pt={8} mt={8}>
          <Text textAlign="center" color={textColor}>
            © {new Date().getFullYear()} HODL Protocol. All rights reserved.
          </Text>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer; 